module.exports = __webpack_public_path__ + "img/financial data.68b258f8.png";